import * as React from 'react';
import Container from '@mui/material/Container';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import {Typography }from '@mui/material';
import { useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AOS from 'aos';
import 'aos/dist/aos.css';

const RoadMapWrapper = styled(Container)`
    display: flex;
    align-items: center;
    background-color:#000;
    padding: 20px 24px;
    @media (min-width: 1024px){
        padding:50px 0px 150px 0px;
    }
    @media (max-width: 1024px){
        padding-top: 50px;
        padding-bottom: 150px;
    }
`
const RoadMapHeading = styled(Typography)`
    font-size:60px;
    text-align:center;
    font-family:poppins;
    font-weight:900;
    color:#F3D332;
    width:100%;
    background-image:url("./assets/Roadmap.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    padding:20px;
    @media (max-width: 749px){
        width:100%;
        font-size:35px;
    }
    @media(min-width: 1900px){
            font-size:170px;
            padding:40px;
        }
    @media (max-width: 1900px) and (min-width: 1300px){
            font-size:90px;
        }
`
const BoxHeader = styled.div`
    padding:0px 20px;
`
const BoxWrapper = styled.div`

`
const BoxHeading = styled(Typography)`
    color:#000;
    font-size:25px;
    font-weight:600;
    font-family:poppins;
    @media (max-width: 749px) and (min-width: 601px){
        font-size:16px;
    }
    @media (min-width: 1200px){
            font-size:30px;
        }
    @media (min-width: 2000px){
            font-size:50px;
            padding: 20px;
        }

`
const BoxText = styled(Typography)`
    color:#fff;
    font-size:18px;
    font-family:poppins;
    display: block;
    @media (max-width: 749px) and (min-width: 601px){
            font-size:11px !important;
        }
    @media (max-width: 1300px){
        font-size:14px;
    }
    @media (min-width: 2000px){
        font-size:35px;
    }
`
const BoxContent = styled.div`
    padding:20px 0px;
    @media (min-width: 2000px){
        padding:20px;
    }

`
const BoxGrid = styled(Grid)`
    @media (max-width: 749px) and (min-width: 601px){
        margin:10px 4px;
    }
    @media (max-width: 600px){
        margin:10px 0px;
    }
    @media(max-width: 1200px) and (min-width: 750px){
        margin:20px 10px;
    }
    margin:50px 20px;
`
const ColunmWrapper = styled.div`
    margin-top:20px;
    @media (min-width: 600px){
        display:flex;
        justify-content:center;
        margin-top:40px;
    }
`
const FooterContainer = styled(Container)`
    background-color:#601E1F;
    padding-bottom:10px;
`
const FooterWrapper = styled(Grid)`
    display:flex;
    justify-content:center;
    flex-direction: column;
    align-items:center;
`
const FooterImg = styled.img`
    width:200px;
    max-width:200px;
    @media (max-width: 1024px){
        width:170px;
        max-width:170px;
    }
    @media (min-width: 2000px){
        width:300px;
        max-width:300px;
    }

`
const SocialLink = styled.a`
    background:#F3D332;
    border-radius:36px;
    padding: 10px;
    margin: 0px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    @media (min-width: 2000px){
        padding: 12px;
        border-radius: 137px;
        height: 60px;
        width: 60px;
        }
`
const SocialImg = styled.img`
    width:22px;
    max-width:22px;
    height:auto;
    @media (min-width: 2000px){
        width:50px;
        max-width:50px;
        height:auto;
        }
`
const SocialWrapper = styled.div`
    display:flex;
    align-items: center;
    margin-top:20px;
    margin-bottom:20px;
    @media (min-width: 2000px){
        margin-top:30px;
        }
`
const CopyRights = styled(Typography)`
    color:#fff;
    text-align:center;
    font-family:poppins;
    font-size:14px;
    padding-bottom:10px;
    @media (min-width: 2000px){
        font-size:28px;
    }
`
const AccordionHeader = styled(AccordionSummary)`
    margin:0px 0px !important;
`
const FooterImgWrapper = styled.div`
    margin-top: -100px;
    background: #000;
    padding: 15px;
    display: flex;
    border-radius: 154px;
    @media (max-width: 1024px){
        padding: 10px;
        }
    @media (max-width: 1999px) and (min-width: 1025px){
        margin-top: -120px;
        }
    @media (min-width:2000px){
        margin-top: -185px;
        border-radius:190px;
        }
`
export default function Roadmap() {
    useEffect(() => {
        AOS.init({duration: 1200,});
      }, [])
     
      const [expanded, setExpanded] = React.useState('panel1');
      const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
      };

    return (
          <>
            <RoadMapWrapper maxWidth="xxl" id="roadmap">
                <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display:'flex' , justifyContent:'center'}}>
                        <RoadMapHeading variant='h1'>
                            Roadmap
                        </RoadMapHeading>
                    </Grid>
                    <ColunmWrapper>
                        <BoxGrid data-aos="fade-right" item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                            <BoxWrapper >
                                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                                    <AccordionHeader
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        >
                                        <BoxHeader>
                                            <BoxHeading variant='p'>
                                                Phase 1
                                            </BoxHeading>
                                        </BoxHeader>
                                    </AccordionHeader>
                                    <AccordionDetails>
                                        <BoxContent>
                                            <BoxText variant='p'>- Design & creation ✔️</BoxText>
                                            <BoxText variant='p'>- Design & creation ✔️</BoxText>
                                        </BoxContent>
                                    </AccordionDetails>
                                </Accordion>
                            </BoxWrapper>
                        </BoxGrid>
                        <BoxGrid data-aos="fade-right" item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                            <BoxWrapper >
                                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                    <AccordionHeader
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        >
                                        <BoxHeader>
                                            <BoxHeading variant='p'>
                                                Phase 2
                                            </BoxHeading>
                                        </BoxHeader>
                                    </AccordionHeader>
                                    <AccordionDetails>
                                        <BoxContent>
                                            <BoxText variant='p'>lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                                                sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
                                                sed diam voluptua. at vero eos et accusam et justo duo dolores et ea rebum. stet
                                                clita kasd gubergren,no sea takimata sanctus est lorem ipsum dolor sit amet.
                                                    lorem ipsum dolor
                                            </BoxText>
                                        </BoxContent>
                                    </AccordionDetails>
                                </Accordion>
                            </BoxWrapper>
                        </BoxGrid>
                        <BoxGrid data-aos="fade-right" item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5}>
                            <BoxWrapper >
                                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                                    <AccordionHeader
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        >
                                        <BoxHeader>
                                            <BoxHeading variant='p'>
                                                Phase 3
                                            </BoxHeading>
                                        </BoxHeader>
                                    </AccordionHeader>
                                    <AccordionDetails>
                                        <BoxContent>
                                            <BoxText variant='p'>lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                                                sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
                                                sed diam voluptua. at vero eos et accusam et justo duo dolores et ea rebum. stet
                                                clita kasd gubergren,no sea takimata sanctus est lorem ipsum dolor sit amet.
                                                    lorem ipsum dolor
                                            </BoxText>
                                        </BoxContent>
                                    </AccordionDetails>
                                </Accordion>
                            </BoxWrapper>
                        </BoxGrid>
                    </ColunmWrapper>
                </Grid>
            </RoadMapWrapper>
            <FooterContainer maxWidth="xxl">
                <Grid container>
                    <FooterWrapper item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <FooterImgWrapper>
                            <FooterImg src="./assets/Tokenomics Image.png" />
                        </FooterImgWrapper>
                        <SocialWrapper>
                            <SocialLink href="#">
                                <SocialImg src="./assets/Path 2345.png" alt="" />
                            </SocialLink>
                            <SocialLink href="#">
                                <SocialImg src="./assets/Twitter.png" alt="" />
                            </SocialLink>
                        </SocialWrapper>
                        <CopyRights variant='p'>
                            ©Baby Psyop all rights reserved
                        </CopyRights>
                    </FooterWrapper>
                </Grid>
            </FooterContainer>
        </>
    );
  }